import React, { Component } from "react";
import FlexView from "react-flexview";
import * as R from "ramda";
import { monthOptions, yearOptions } from "../config";
import { removeNullFields } from "../../../../common/mapper";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import TeamLeaderProspectReport from "./component/teamLeaderProspectReport";
import SalesmanProspectReport from "./component/salesmanProspectReport";
import { connect } from "react-redux";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import Container from "../../../../../modules/commons/Container";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { mapToObjectDDL } from "../../../../common/mapper";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus } from "../../../../common/Constants";

class ProspectMonitoringTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSpecificSelected: false,
      dataCabang: [],
      kodeCabang: [],
      search: [],
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
      dataTableSalesman: [],
      listTeamLead: [],
      selectedTL: null,
      activeIndex: 0,
    };
  }

  componentDidMount = async () => {
    this.fetchDataCabang();
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      // month: monthOptions.find((item) => item.value === currentDate.getMonth()),
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear()
      ),
      dataTable: [],
      dataTableSalesman: [],
    }));
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!R.equals(prevState.kodeCabang, this.state.kodeCabang)) {
      this.fetchTeamLeaderData();
      this.setState({
        selectedTL: null
      })
    }
  }

  fetchDataCabang = async () => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Cabang Keatas dan Admin CRM - Laporan Prspek Monitoring Tim",
      args: null,
    });
    if (res.ok) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang)
      );
      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData,
          kodeCabang: filteredData?.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          )[0],
        }));
      }
    }
  };

  fetchTeamLeaderData = async () => {
    try {
      this.handleTriggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Team Leader - Laporan Statistik Prospek Per Team Leader",
        args: { paramFilters: { kodeCabang: this.state.kodeCabang?.value, userNameLead: this.props.auth.user.username } },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          listTeamLead: res.data.data,
        }));
      }
      this.handleTriggerLoading();
    } catch (error) {
      console.log("errors", error);
    }
  };

  handleChangeCabang = (value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      kodeCabang: value,
      dataTable: [],
      dataTableSalesman: []
    }));
  };

  handleSearch = async () => {
    this.fetchData();
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
      dataTable: [],
      dataTableSalesman: []
    }));
  };

  fetchData = async () => {
    this.handleTriggerLoading();
    console.log(this.state.selectedTL?.value)
    const fn = this.state.activeIndex === 1 ? "getLaporanStatistikSalesCS" : "getLaporanStatistikTeamLead"
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO")[fn],
      setError: this.props.setError,
      menuName:
        "Dashboard Level Team Leader - Laporan Statistik Prospek Per Team Leader",
      args: removeNullFields({
        kodeCabangList: [this.state.kodeCabang?.value],
        month: this.state.month?.value,
        year: this.state.year?.value,
        teamLeaderEmployeeId: this.state.selectedTL?.value || this.props.auth?.user?.idUser,
      }),
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const key = this.state.activeIndex === 1 ? "dataTableSalesman" : "dataTable";
      this.setState((prevValue) => ({
        ...prevValue,
        [key]: res.data.data,
      }));
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleSelectTL = (value) => {
    this.setState({
      selectedTL: value,
    });
  };

  handleResetTab = (value) => {
    this.setState(prev=>({
        ...prev,
        selectedTL: null,
        dataTable: [],
        dataTableSalesman: [],
        activeIndex: value
    }))
  }

  render() {
    return (
      <>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <FlexView style={{ gap: "20px", alignItems: "flex-end" }}>
              <SimpleDDL
                isClearable
                id="select_options_branch"
                box="search"
                label="Cabang"
                placeholder="CABANG"
                name="kodeCabang"
                containerclassname="width width-250px"
                options={this.state.dataCabang.map((item) =>
                  mapToObjectDDL(item.namaDealer, item.kodeCabang)
                )}
                value={this.state.kodeCabang}
                onChange={(value) => this.handleChangeCabang(value)}
              />
              <SimpleDDL
                isClearable
                id="select_options_month"
                box="search"
                name="month"
                containerclassname="width width-250px"
                placeholder="Bulan"
                menuPosition="fixed"
                options={monthOptions}
                value={this.state.month}
                onChange={(value, { name }) =>
                  this.handleChangeSearchValue(name, value)
                }
              />
              <SimpleDDL
                isClearable
                id="select_options_year"
                box="search"
                name="year"
                containerclassname="width width-250px"
                placeholder="Tahun"
                menuPosition="fixed"
                options={yearOptions}
                value={this.state.year}
                onChange={(value, { name }) =>
                  this.handleChangeSearchValue(name, value)
                }
              />
            </FlexView>
            <SimpleButton onClick={() => this.handleSearch()}>
              Cari
            </SimpleButton>
          </FlexView>
          <Tabs 
            onSelect={this.handleResetTab}
          >
            <TabList>
              <Tab>Laporan Statistik Prospek Per TL</Tab>
              <Tab>Laporan Statistik Prospek Per Salesman / CS</Tab>
            </TabList>
            <TabPanel>
              <TeamLeaderProspectReport
                {...this.props}
                dataTable={this.state.dataTable}
              />
            </TabPanel>
            <TabPanel>
              <SalesmanProspectReport
                {...this.props}
                listTeamLead={this.state.listTeamLead}
                selectedTL={this.state.selectedTL}
                dataTable={this.state.dataTableSalesman}
                onSelectTL={this.handleSelectTL}
                onSearch={this.fetchData}
              />
            </TabPanel>
          </Tabs>
          {this.state.loading && (
            <SimpleLoadingOverlay active={this.state.loading} />
          )}
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProspectMonitoringTeam);
